import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { MarketingInfoFragmentDoc } from '../../fragments/__generated__/MarketingInfo.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MarketingInfoQueryVariables = Types.Exact<{
  salesChannelName?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type MarketingInfoQuery = { marketingInfo: { salesCount: number, positiveFeedbackCount: number } };


export const MarketingInfoDocument = gql`
    query MarketingInfo($salesChannelName: String) {
  marketingInfo(salesChannelName: $salesChannelName) {
    ...MarketingInfoFragment
  }
}
    ${MarketingInfoFragmentDoc}`;

/**
 * __useMarketingInfoQuery__
 *
 * To run a query within a React component, call `useMarketingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketingInfoQuery({
 *   variables: {
 *      salesChannelName: // value for 'salesChannelName'
 *   },
 * });
 */
export function useMarketingInfoQuery(baseOptions?: Apollo.QueryHookOptions<MarketingInfoQuery, MarketingInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketingInfoQuery, MarketingInfoQueryVariables>(MarketingInfoDocument, options);
      }
export function useMarketingInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketingInfoQuery, MarketingInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketingInfoQuery, MarketingInfoQueryVariables>(MarketingInfoDocument, options);
        }
export type MarketingInfoQueryHookResult = ReturnType<typeof useMarketingInfoQuery>;
export type MarketingInfoLazyQueryHookResult = ReturnType<typeof useMarketingInfoLazyQuery>;
export type MarketingInfoQueryResult = Apollo.QueryResult<MarketingInfoQuery, MarketingInfoQueryVariables>;
export function refetchMarketingInfoQuery(variables?: MarketingInfoQueryVariables) {
      return { query: MarketingInfoDocument, variables: variables }
    }